import { observable } from "mobx";

import OrganizationStructure from "@model/OrganizationStructure";

export default class OrganizationUnit extends OrganizationStructure {
  @observable unit_type?: string;
}
